/**
 * Snowplow events for the session-wide observe capture.
 *
 * Filed under the consent category so the capture counts sit beside the consent counts they are
 * compared with.
 */
import { trackStructEvent } from "@snowplow/browser-tracker";

import { type CaptureEligibilityReason } from "@/types/observeCapture";
import { Day1EventAction, Day1EventCategory } from "@/types/snowplow-events";

const category = Day1EventCategory.AiJourneyConsent;

/** Sends one CAPTURE-ELIGIBILITY event, with the reason as the label. */
export const emitCaptureEligibility = (
  reason: CaptureEligibilityReason
): void => {
  trackStructEvent({
    category,
    action: Day1EventAction.CaptureEligibility,
    label: reason,
  });
};

/**
 * The widget asked the host to start a recording, and the IPC send returned. This does not prove
 * that the host started the recording.
 */
export const emitCaptureStarted = (): void => {
  trackStructEvent({
    category,
    action: Day1EventAction.CaptureStarted,
  });
};
